//Brand Colors
export const turquoise = {
  50: '#E0F6F8',
  100: '#B3E7EB',
  200: '#80D7DD',
  300: '#4DC7CF',
  400: '#26B4BE',
  500: '#0FA2AC',
  600: '#048B99', // PRIMARY
  700: '#03717D',
  800: '#035861',
  900: '#023D44',
}

// Secondary Brand Colors (Orange)
export const orange = {
  50: '#FFF5F0',
  100: '#FFE2D3',
  200: '#FFC2A3',
  300: '#FFA073',
  400: '#FC8550',
  500: '#F97B3A', // SECONDARY
  600: '#F37237',
  700: '#D66230',
  800: '#B9512A',
  900: '#8F3D1F',
}

export const gray = {
  50: '#fafafa', // Lightest background
  100: '#f5f5f5', // Light background
  200: '#f0f0f0', // Very light border
  300: '#d9d9d9', // Light border
  400: '#bfbfbf', // Medium border
  500: '#8c8c8c', // Secondary text
  600: '#595959', // Body text
  700: '#434343', // Heading text
  800: '#262626', // Dark text
  900: '#1f1f1f', // Darkest text
}

// Semantic Colors
export const semantic = {
  success: {
    50: '#f6ffed',
    100: '#d9f7be',
    200: '#b7eb8f',
    300: '#95de64',
    400: '#73d13d',
    500: '#52c41a',
    600: '#389e0d',
    700: '#237804',
    800: '#135200',
    900: '#092b00',
  },
  warning: {
    50: '#fffbe6',
    100: '#fff1b8',
    200: '#ffe58f',
    300: '#ffd666',
    400: '#ffc53d',
    500: '#faad14',
    600: '#d48806',
    700: '#ad6800',
    800: '#874d00',
    900: '#613400',
  },
  error: {
    50: '#fff2f0',
    100: '#ffccc7',
    200: '#ffa39e',
    300: '#ff7875',
    400: '#ff4d4f',
    500: '#f5222d',
    600: '#cf1322',
    700: '#a8071a',
    800: '#820014',
    900: '#5c0011',
  },
  info: {
    50: '#e6f7ff',
    100: '#bae7ff',
    200: '#91d5ff',
    300: '#69c0ff',
    400: '#40a9ff',
    500: '#1890ff',
    600: '#096dd9',
    700: '#0050b3',
    800: '#003a8c',
    900: '#002766',
  },
}

// Design Tokens
export const colors = {
  // Primary brand colors
  primary: turquoise[600],
  primaryHover: turquoise[500],
  primaryActive: turquoise[700],
  primaryLight: turquoise[100],
  primaryBg: turquoise[50],

  // Secondary brand colors
  secondary: orange[500],
  secondaryHover: orange[400],
  secondaryActive: orange[600],
  secondaryLight: orange[100],
  secondaryBg: orange[50],

  // Gray tokens for consistent usage
  gray: {
    background: gray[50],
    backgroundSecondary: gray[100],
    border: gray[200],
    borderSecondary: gray[300],
    text: gray[600],
    textSecondary: gray[500],
    textTertiary: gray[400],
    textQuaternary: gray[300],
  },

  // Semantic tokens
  success: semantic.success[500],
  successLight: semantic.success[100],
  successBg: semantic.success[50],

  warning: semantic.warning[500],
  warningLight: semantic.warning[100],
  warningBg: semantic.warning[50],

  error: semantic.error[500],
  errorLight: semantic.error[100],
  errorBg: semantic.error[50],

  info: semantic.info[500],
  infoLight: semantic.info[100],
  infoBg: semantic.info[50],
}

// Legacy exports for backward compatibility
export const background = gray[50]
export const backgroundSecondary = gray[100]
